import React from 'react';

import classNames from 'classnames';

import { RDS_ICON } from '../Icon';

const SystemArrowLeft = React.forwardRef<
  HTMLSpanElement, // The reference type - which element the final ref is attached to.
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...spanProps }, forwardedRef) => {
  // System Icons are size 16 only
  const iconClasses = classNames(RDS_ICON, `${RDS_ICON}-16`, className);

  // Spans are used here for sizing the SVG and to keep in line with the current styles
  // TODO: explore decoupling the svg itself from the outer contents: https://jira.rallyhealth.com/browse/UCRON-1455
  return (
    <span ref={forwardedRef} {...spanProps} className={iconClasses}>
      <span>
        <svg
          focusable="false"
          height="16"
          role="presentation"
          viewBox="0 0 16 16"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.016.21l.094.083a1.001 1.001 0 01.084 1.32l-.083.096-5.269 5.288H15a1 1 0 01.707 1.709 1 1 0 01-.707.293H3.832l5.28 5.302a1.003 1.003 0 01-1.32 1.5l-.095-.084L0 8l1.271-1.27L7.697.293A1 1 0 019.016.21z"
            clipRule="evenodd"
            fillRule="evenodd"
          />
        </svg>
      </span>
    </span>
  );
});

export default SystemArrowLeft;
